import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GenericFormWindowComponent } from './generic-form-window/generic-form-window.component';
import { CustomFabComponent } from './custom-fab/custom-fab.component';
import { StickySnackbarComponent } from './sticky-snackbar/sticky-snackbar.component';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { FileUploaderComponent } from './file-uploader/file-uploader.component';
import { GenericFormButtonsComponent } from './generic-form-buttons/generic-form-buttons.component';
import { CustomDialogComponent } from './custom-dialog/custom-dialog.component';
import { DropdownComponent, DropdownService} from './dropdown/dropdown.component';
import {
  MatButtonModule, MatCheckboxModule, MatCardModule, MatToolbarModule, MatSidenavModule, MatIconModule, MatInputModule, MatRadioModule, MatFormFieldModule,
  MatSelectModule, MatDatepickerModule, MatNativeDateModule, MatProgressSpinnerModule, MatTabsModule
} from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CotFormControlComponent } from './cot-form-control/cot-form-control.component';
import { CotAnalysisFormComponent } from './cot-analysis-form/cot-analysis-form.component';
import { CotParentalConsentFormComponent } from './cot-parental-consent-form/cot-parental-consent-form.component';
import { SafeHtmlModule } from '../services/safeHtml';
import { CotUdfsRegularFormComponent } from './cot-udfs-regular-form/cot-udfs-regular-form.component';

@NgModule({
  imports: [CommonModule, FlexLayoutModule, FormsModule, ReactiveFormsModule,
    MatButtonModule, MatCheckboxModule, MatCardModule, MatToolbarModule, MatSidenavModule, MatIconModule, MatInputModule, MatRadioModule, MatFormFieldModule,
    MatSelectModule, MatDatepickerModule, MatNativeDateModule, MatProgressSpinnerModule, MatTabsModule,
    SafeHtmlModule
  ],
  exports: [GenericFormWindowComponent, CustomFabComponent, StickySnackbarComponent, LoadingSpinnerComponent, FileUploaderComponent, GenericFormButtonsComponent, CustomDialogComponent,
    DropdownComponent, CotFormControlComponent, CotAnalysisFormComponent, CotParentalConsentFormComponent, CotUdfsRegularFormComponent],
  declarations: [GenericFormWindowComponent, CustomFabComponent, StickySnackbarComponent, LoadingSpinnerComponent, FileUploaderComponent, GenericFormButtonsComponent, CustomDialogComponent,
    DropdownComponent, CotFormControlComponent, CotAnalysisFormComponent, CotParentalConsentFormComponent, CotUdfsRegularFormComponent],
  providers: [DropdownService ]
})

export class WidgetsModule { }



// WEBPACK FOOTER //
// ./src/app/widgets/widgets.module.ts